var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "marketing-address-disclaimer",
      "footer-close-button-text": _vm.$t("global.words.no"),
      "modal-dialog-size": "md",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("drip-campaigns.modals.delete.title")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("drip-campaigns.modals.delete.subtitle")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "danger",
                  text: "Yes",
                  loading: _vm.deletingCampaign,
                },
                on: { click: _vm.handleDeleteDripCampaign },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.yes")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }